import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OK_LABEL } from '@common/constants';
import { IAlertDialogData } from 'src/app/core/models/dialog.model';
import { CBXDialogData } from '../../services/dialog/dialog.service';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent implements OnInit {

  buttonLabel:string = "";
  mode:any=this.commonService.getApplicationMode();
  constructor(
    private dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: CBXDialogData,
    public commonService:CommonService
  ) { }

  ngOnInit(): void {
    // this.buttonLabel = this.data.buttonLabel ? this.data.buttonLabel : OK_LABEL;
  }

  ok(){
    this.dialogRef.close(1);
  }

}
